import React, { useContext } from "react";
import { Switch, Route } from "react-router-dom";
import { isEmpty } from "lodash";
import { Container } from "react-bootstrap";
import { Grid } from "@material-ui/core";
import { UserContext } from "../context/UserContext";
import { ContentFinderProvider } from "../context/ContentFinderContext";
import AppBar from "../components/headerNav/HeaderNav";
import ContentFinderRequest from "../components/content-finder/ContentFinderRequest";
import ContentFinderSearchDetails from "../components/content-finder/ContentFinderSearchDetails";
import ContentFinderFeatureDetails from "../components/content-finder/ContentFinderFeatureDetails";
import Footer from "../components/footer/Footer";
import CookieConsentBanner from "../components/cookie-consent/CookieConsentBanner";

const ContentFinder = () => {
  const { userRole } = useContext(UserContext);

  return isEmpty(userRole) ? null : (
    <Container fluid className="requestContainer">
      <Grid container>
        <ContentFinderProvider>
          <AppBar />
          <Grid item xs={12}>
            <Container fluid className="media-request-container">
              <Switch>
                <Route exact path="/legacyGmsc">
                  <ContentFinderRequest />
                </Route>
                <Route exact path="/legacyGmsc/series/:titleId">
                  <ContentFinderSearchDetails />
                </Route>
                <Route exact path="/legacyGmsc/feature/:titleId">
                  <ContentFinderFeatureDetails />
                </Route>
              </Switch>
            </Container>
          </Grid>
          <Footer />
          <CookieConsentBanner />
        </ContentFinderProvider>
      </Grid>
    </Container>
  );
};

export default ContentFinder;
